import React, { Component } from 'react';
import './ScheduledTime.css';
import { get, post } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
// import { getFreshToken } from '../../custom_libraries/auth';
import urls from '../../custom_libraries/urls';
import { Button } from '@mui/material';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class ScheduledTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scheduledTime: '',
      scheduledDays: [],  // <-- Add this line!
      success: false,
      warning: false,
      error: false,
      error1: false,
      open_progress_bar: false,
      slider1: 5,
      slider2: 5,
      slider3: 5,
      toggle1: false,
      toggle2: false,
      loading: false,
      slidersModified: false, // NEW STATE
      storedLogo: localStorage.getItem("USER_LOGO") || null,
    };
  }

  componentDidMount() {
    this.fetchUserSettings();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.error !== prevState.error ||
      this.state.error1 !== prevState.error1 ||
      this.state.success !== prevState.success ||
      this.state.warning !== prevState.warning
    ) {
      if (
        this.state.error ||
        this.state.error1 ||
        this.state.success ||
        this.state.warning
      ) {
        setTimeout(() => {
          this.setState({
            error: false,
            success: false,
            error1: false,
            warning: false
          });
        }, 3000); // 3 second
      }
    }
  }

  fetchUserSettings = async () => {
  console.log("--------EmailAddress tab---------");
  try {
    this.startLoading();

    const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_token}`
    };

    const response = await get(urls.NOTIFICATION_SETTINGS_LIST, headers);
    this.stopLoading();

    console.log(urls.NOTIFICATION_SETTINGS_LIST, "response of schedule fetch 1===> <", response);

    if (!response || response.length === 0) {
      console.warn("Empty response received.");
      this.setState({ warning: true });
      return;
    }

    const data = response[0]; // Assuming it's an array

    this.setState({
      email: data.email_addresses || '',
      scheduledTime: data.schedule_email_time || '', // Not `scheduled_time` — use `schedule_email_time`
      scheduledDays: data.schedule_days_of_week ? data.schedule_days_of_week.split(',') : [],
      slider1: data.detection_settings?.blur_detection ?? 5,
      slider2: data.detection_settings?.tilt_detection ?? 5,
      slider3: data.detection_settings?.block_detection ?? 5,
    });

  } catch (error) {
    console.error("Error fetching user settings:", error);
    this.setState({ error1: true });
    this.stopLoading();
  }
};

  jsonData = () => {
  return JSON.stringify({
    email_addresses: this.state.email,
    schedule_email_time: this.state.scheduledTime,
    schedule_days_of_week: (this.state.scheduledDays || []).join(','),
    detection_settings: {
      blur_detection: parseInt(this.state.slider1), // or this.state.blur_detection
      tilt_detection: parseInt(this.state.slider2),
      block_detection: parseInt(this.state.slider3)
    }
  });
};

  handleTimeChange = (event) => {
    this.setState({ scheduledTime: event.target.value });
  };

   // Submit it to the backend
handleSave = async () => {
  console.log("Scheduled Time Saved:", this.state.scheduledTime);
  const payload = this.jsonData();
  console.log("Payload being sent to API:", payload);

  this.startLoading();

  const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
  const headers = {
    'content-type': 'application/json',
    'Authorization': `Bearer ${access_token}`
  };

  try {
    const response = await post(urls.NOTIFICATION_SETTINGS_CREATE, payload, headers);
    console.log("response of email save===> ", response);
    this.stopLoading();

    if (response !== false) {
      this.setState({ success: true });
    } else {
      this.setState({ error: true });
    }
  } catch (err) {
    console.error("Save error:", err);
    this.setState({ error: true });
    this.stopLoading();
  }
};

saveDetectionSettings = async () => {
  const { slider1, slider2, slider3 } = this.state;
  let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
  let headers = {
    'content-type': 'application/json',
    'Authorization': `Bearer ${access_token}`
  };

  // Prepare the data to be sent
  const data = {
    detection_settings: {
      block_detection: slider1,
      blur_detection: slider2,
      tilt_detection: slider3,
    }
  };

  this.startLoading(); // Show loading spinner

  try {
    // Send updated detection settings to backend
    const response = await post(urls.NOTIFICATION_SETTINGS_CREATE, JSON.stringify(data), headers);
    
    if (response && response.id) {
      // Handle success - update the state with the new data
      this.setState({
        detection_settings: response.detection_settings,
        success: true
      });
      console.log("Detection settings updated successfully:", response);
    } else {
      this.setState({ error: true });
      console.error("Error updating detection settings");
    }
  } catch (error) {
    this.setState({ error: true });
    console.error("Error while saving detection settings:", error);
  } finally {
    this.stopLoading(); // Hide loading spinner
  }
};



  startLoading = () => {
    this.setState({ open_progress_bar: true })
  }

  stopLoading = () => {
    this.setState({ open_progress_bar: false })
  }

  // Slider event handlers
 handleSlider1Change = (event) => {
  this.setState({ slider1: event.target.value, slidersModified: true });
};

handleSlider2Change = (event) => {
  this.setState({ slider2: event.target.value, slidersModified: true });
};

handleSlider3Change = (event) => {
  this.setState({ slider3: event.target.value, slidersModified: true });
};


  getSliderBackground = (value) => {
    // const percentage = (value / 10) * 100;
    return `linear-gradient(to right, green ${value}%, yellow ${value}%, red 100%)`;
  };

 resetSliders = async () => {
  this.setState({
    slider1: 5,
    slider2: 5,
    slider3: 5,
    slidersModified: true,
  });
};



  // Toggle Switch 
  handleToggle1Change = () => {
    this.setState((prevSate) => ({ toggle1: !prevSate.toggle1 }));
  };

  handleToggle2Change = () => {
    this.setState((prevSate) => ({ toggle2: !prevSate.toggle2 }));
  };


  render() {
    const { error, success, error1, warning, slider1, slider2, slider3, loading, scheduledTime, email, scheduledDays} = this.state;
    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <div className="scheduled-time-page" style={{ marginLeft: '3%' }}>
          <>
            <div className="scheduled-time-alert" style={{ marginLeft: '6%', width: '80%' }}>
              {error ? (
                <Alert severity="error">Error saving emails. Please try again!</Alert>
              ) : success ? (
                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                  "Scheduled time settings saved successfully."
                </Alert>
              ) : warning ? (
                <Alert severity="warning">"No time is scheduled!"</Alert>
              ) : error1 ? (
                <Alert severity="error">"Server Error occurred while fetching user settings..."</Alert>
              ) : null}
            </div>
            {/* <div className="scheduled-time" style={{ maxWidth: "50%", marginTop: "5%" }}>
              <h3>Scheduled times for email delivery</h3>
              <p style={{ fontSize: "14px", marginBottom: "10px", textAlign: "justify" }}>
                Last time(s) to receive a report with detailed status information about each of the devices in your account current to the scheduled time of this email. You can schedule daily, weekly, or monthly emails.
              </p>
              <input
                className="timepicker"
                type="time"
                id="appt"
                name="scheduled_time"
                value={this.state.scheduledTime}
                onChange={this.handleTimeChange}
              />
              <div style={{ marginTop: "10px" }}>
                <div>
                  <Button
                    id="rowsPerPageButton"
                    style={{ marginTop: '8px' }}
                    onClick={this.handleSave}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div> */}

            {/* Camera Health Section */}
            {/* <div className="cameraHealthContainer">
              <h3 className="cameraHealthHeading"></h3>
              <ul className="cameraHealthList">
                <li>() Camera: Definitely Healthy</li>
                <li>() Camera: Healthy</li>
                <li>() Camera: Affected</li>
                <li>() Camera: Unwell</li>
              </ul>
            </div> */}
            <div className="sensitivity-wrapper">
              <div className="sensitivity-layout">
                {/* Left: Slider Section */}
                <div className="slider-panel">
                  <h2 style={{ marginBottom: '28px',  textAlign: 'center',fontSize: '15px' }}>AI Engine</h2>

                  <div className="sliderItems">
                    <label htmlFor="blur-detection-slider" style={{ marginBottom: '10px', display: 'block', fontSize: '14px' }}>Blur detection: {slider1}</label>
                    <input
                      id="blur-detection-slider"
                      type="range"
                      min="0"
                      max="10"
                      value={slider1}
                      onChange={this.handleSlider1Change}
                      style={{ background: this.getSliderBackground(slider1) }}
                    />
                  </div>

                  <div className="sliderItems">
                    <label htmlFor="tilt-detection-slider" style={{ marginBottom: '10px', display: 'block', fontSize: '14px' }}>Tilt detection: {slider2}</label>
                    <input
                      id="tilt-detection-slider"
                      type="range"
                      min="0"
                      max="10"
                      value={slider2}
                      onChange={this.handleSlider2Change}
                      style={{ background: this.getSliderBackground(slider2) }}
                    />
                  </div>

                  <div className="sliderItems">
                    <label htmlFor="block-detection-slider" style={{ marginBottom: '10px', display: 'block', fontSize: '14px' }}>Block detection: {slider3}</label>
                    <input
                      id="block-detection-slider"
                      type="range"
                      min="0"
                      max="10"
                      value={slider3}
                      onChange={this.handleSlider3Change}
                      style={{ background: this.getSliderBackground(slider3) }}
                    />
                  </div>

                <div className="sensitivityButtonGroup">
                <Button
                  id="rowsPerPageButton" style={{marginTop:"10px"}}
                  onClick={this.handleSave}
                  disabled={loading}
                >
                  {loading ? <span className="spinner" /> : 'Save Sensitivity'}
                </Button>

                <Button
                  id="rowsPerPageButton" style={{marginTop:"10px"}}
                  onClick={this.resetSliders}
                  aria-label="Reset Sliders"
                  disabled={this.state.refreshLoading}
                >
                  {this.state.refreshLoading ? (
                    <>
                      <span className="spinner" /> Refreshing...
                    </>
                  ) : (
                    "Reset"
                  )}
                </Button>
              </div>
                </div>

                {/* Right: How it Works Section */}
              <div className="how-it-works-panel">
                <h3>How it works?</h3>
                <div className="how-it-works-content" style={{ fontSize: '15px', lineHeight: '1.6', paddingLeft: '20px' }}>
                  <p style={{ marginBottom: '8px' }}>1. Control camera sensitivity using the sliders.</p>
                  <p style={{ marginBottom: '8px' }}>2. Lower values (left side) show more healthy (green) cameras.</p>
                  <p style={{ marginBottom: '8px' }}>3. Higher values are more aggressive in marking issues.</p>
                  <p style={{ marginBottom: '8px' }}>4. Click "Save Sensitivity" to apply changes.</p>
                  <p style={{ marginBottom: '8px' }}>
                    <strong><span style={{ color: 'lightseagreen' }}>Note :</span></strong> Press the Reset button to return all sliders to their default values.
                  </p>
                </div>
              </div>

                          {/* </div> */}


                          {/* Save Button */}
                          {/* <div className="saveButtonContainer">
                            <button className="saveSensitivityButton" onClick={this.handleSave} disabled={loading}>
                              {loading ? (
                                <span className="spinner" />
                              ) : (
                                'Save Sensitivity'
                              )}
                            </button>
                          </div> */}


                          {/* Line Break Between Sliders and Toggles */}
                          {/* <div className="lineBreak"></div> */}


                          {/* Toggle Switches Container */}
                          {/* First Toggle Switch */}
                          {/* <div className="toggleSwitch">
                            <label
                              className={`toggle ${this.state.toggle1 ? 'on' : 'off'}`}
                              onClick={this.handleToggle1Change}
                            >
                              <span className="slider"></span>
                            </label>
                            <span style={{ marginLeft: '10px', alignSelf: 'center' }}></span>
                          </div> */}


                          {/* Line Break Between Sliders and Toggles */}
                          {/* <div className="lineBreak"></div> */}


                          {/* Second Toggle Switch */}
                          {/* <div className="toggleSwitch">
                            <label
                              className={`toggle ${this.state.toggle2 ? 'on' : 'off'}`}
                              onClick={this.handleToggle2Change}
                            >
                              <span className="slider"></span>
                            </label>
                            <span style={{ marginLeft: '10px', alignSelf: 'center' }}></span>
                          </div> */}

              </div>
            </div>

          </>
          <Backdrop open={this.state.open_progress_bar}>
            <div className="custom-spinner">
              <div className="circle"></div>
              <div className="circle tilted"></div>
              <img
                src={this.state.storedLogo ? this.state.storedLogo : WebLogo}
                alt="web-logo"
                style={{ backgroundColor: '#2d4d85', borderRadius: '100px' }}
              />
            </div>
          </Backdrop>
        </div>
      </ThemeProvider>
    );
  }
}

export default ScheduledTime;
